import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import AssetEditor from './AssetEditor';

function EditAsset() {
	const { id } = useParams();
	const navigate = useNavigate();

	return (
		<EntityList>
			<Helmet>
				<title>Editar Activo</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Activos fijos', to: '/AdminScreen/assets' },
					{ label: 'Editar Activo' },
				]}
				title='Editar Activo'
				subtitle='Actualizá los datos principales del activo.'
			/>
			<AssetEditor
				mode='edit'
				assetId={id}
				allowCreateRoundTrip
				onCancel={() => navigate(`/AdminScreen/assets/asset/${id}`)}
				onSaved={(savedAssetId) => navigate(`/AdminScreen/assets/asset/${savedAssetId || id}`)}
				saveLabel='Guardar'
			/>
		</EntityList>
	);
}

export default EditAsset;
